import React from 'react';
import { defineMessages, useIntl } from 'react-intl';
import { Container } from '@plone/components';
import Icon from '@plone/volto/components/theme/Icon/Icon';
import mailSVG from '@plone/volto/icons/email.svg';
import phoneSVG from '@plone/volto/icons/mobile.svg';
import type { Person } from '@ifpb/portal/types/content';

const messages = defineMessages({
  phone: {
    id: 'Telefone',
    defaultMessage: 'Telefone',
  },
  email: {
    id: 'eMail',
    defaultMessage: 'eMail',
  },
});

const ContactInfo = ({ content }: { content: Person }) => {
  const intl = useIntl();
  return (
    <Container className="contact-info">
      {content.contact_email && (
        <div className="summary-extra-info">
          <Icon
            title={intl.formatMessage(messages.email)}
            name={mailSVG}
            size="24px"
          />
          <a href={`mailto:${content.contact_email}`}>
            {content.contact_email}
          </a>
        </div>
      )}
      {content.contact_phone && (
        <div className="summary-extra-info">
          <Icon
            title={intl.formatMessage(messages.phone)}
            name={phoneSVG}
            size="24px"
          />
          <a href={`tel:${content.contact_phone}`}>{content.contact_phone}</a>
        </div>
      )}
    </Container>
  );
};

export default ContactInfo;
